module.exports = __webpack_public_path__ + "img/uestcp-logo.b542cbb9.png";